var _path, _circle, _circle2, _path2, _circle3, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63916 8.75H1.63916C1.08688 8.75 0.63916 9.19772 0.63916 9.75V14.75C0.63916 15.3023 1.08688 15.75 1.63916 15.75H12.6392C13.1914 15.75 13.6392 15.3023 13.6392 14.75V9.75C13.6392 9.19772 13.1914 8.75 12.6392 8.75H10.6392",
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.88916,
    cy: 5.25,
    r: 1.25,
    fill: "#333333",
    stroke: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.13916,
    cy: 2.5,
    r: 1.25,
    fill: "#333333",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13916 12.25V6.25C5.13916 5.91667 4.93916 5.25 4.13916 5.25C3.33916 5.25 3.13916 5.25 3.13916 5.25",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.25,
    transform: "matrix(-1 0 0 1 12.3892 5.25)",
    fill: "#333333",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13916 12.25V6.25C9.13916 5.91667 9.33916 5.25 10.1392 5.25C10.9392 5.25 11.1392 5.25 11.1392 5.25",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13916 3.75V13.75",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13916 15.75L7.13916 17.75",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63916 18.25H4.63916",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.baf6cc1eec8a3aee308c371cec3a67ec.svg";
export { ForwardRef as ReactComponent };